
/**
 * Admin Feature Flag Alert Component
 * 
 * Displays an alert with a link to the feature flag admin page for super administrators
 */
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/auth/useAuth';
import { hasSuperAdminAccess } from '@/context/auth/types';
import { AlertCircle } from 'lucide-react';

/**
 * Admin feature flag alert component
 * 
 * Only shows to users with super_admin access
 */
const AdminFeatureFlagAlert: React.FC = () => {
  const { user } = useAuth();
  
  // Only show for super_admin users
  const isSuperAdmin = user ? hasSuperAdminAccess(user.role) : false;
                 
  if (!isSuperAdmin) {
    return null;
  }
  
  return (
    <Alert className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Feature Flag Management Available</AlertTitle>
      <AlertDescription>
        The application is currently being refactored with feature flags.{' '}
        <Link to="/admin/features" className="font-medium underline hover:text-primary">
          Manage feature flags
        </Link>{' '}
        to enable or disable new features.
      </AlertDescription>
    </Alert>
  );
};

export default AdminFeatureFlagAlert;
